import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

import ProfileDropdown from "../Components/Common/ProfileDropdown";
import SearchOption from "../Components/Common/SearchOption";
import NotificationDropdown from "../Components/Common/NotificationDropdown";
import LightDark from "../Components/Common/LightDark";

import { changeSidebarVisibility } from "../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";


const Header = ({
    onChangeLayoutMode,
    layoutModeType,
    headerClass,
}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();




    /* =========================================
       SIDEBAR STATE
    ========================================= */

    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (sidebarVisibilitytype) =>
            sidebarVisibilitytype.sidebarVisibilitytype
    );

    const sidebarVisibilitytype = useSelector(selectDashboardData);


    /* =========================================
       DESKTOP SIDEBAR TOGGLE
    ========================================= */

    const toggleMenuBtn = () => {

        const windowSize = document.documentElement.clientWidth;

        // =========================================
        // MOBILE / TABLET
        // =========================================
        if (windowSize <= 991) {

            document.body.classList.toggle(
                "vertical-sidebar-enable"
            );

            return;
        }

        // =========================================
        // DESKTOP
        // =========================================

        const newState =
            sidebarVisibilitytype === "show"
                ? "hidden"
                : "show";

        dispatch(changeSidebarVisibility(newState));

        const hamburger =
            document.querySelector(".hamburger-icon");

        if (hamburger) {
            hamburger.classList.toggle("open");
        }

        // =========================================
        // DESKTOP SIDEBAR SIZE
        // =========================================

        if (
            document.documentElement.getAttribute("data-layout") ===
            "vertical" ||
            document.documentElement.getAttribute("data-layout") ===
            "semibox"
        ) {

            if (windowSize > 1025) {

                document.documentElement.setAttribute(
                    "data-sidebar-size",
                    document.documentElement.getAttribute(
                        "data-sidebar-size"
                    ) === "lg"
                        ? "sm"
                        : "lg"
                );

            } else if (windowSize > 767) {

                document.documentElement.setAttribute(
                    "data-sidebar-size",
                    document.documentElement.getAttribute(
                        "data-sidebar-size"
                    ) === "sm"
                        ? ""
                        : "sm"
                );
            }
        }
    };

    /* =========================================
       MOBILE MENU TOGGLE
    ========================================= */


    /* =========================================
       LOGO
    ========================================= */

    const handleLogoClick = () => {

        navigate("/leads");

    };


    /* =========================================
       USER
    ========================================= */

    const storedUser =
        localStorage.getItem("user");

    let parsedUser = {};

    try {

        parsedUser = storedUser
            ? JSON.parse(storedUser)
            : {};

    } catch (error) {

        parsedUser = {};

    }


    const userName =
        parsedUser?.name ||
        parsedUser?.username ||
        parsedUser?.user_name ||
        "Sachin";


    const userAvatar =
        parsedUser?.profileImage ||
        parsedUser?.image ||
        parsedUser?.avatar ||
        "/assets/images/users/user-dummy-img.jpg";


    /* =========================================
       CLOSE MOBILE MENU
    ========================================= */

    return (
        <>

            {/* =====================================
                HEADER
            ===================================== */}

            <header
                id="page-topbar"
                className={`crm-modern-header ${headerClass || ""}`}
            >

                <div className="layout-width">

                    <div className="navbar-header">


                        {/* =================================
                            LEFT SECTION
                        ================================= */}

                        <div className="d-flex align-items-center">


                            {/* LOGO */}

                            <div className="navbar-brand-box horizontal-logo">

                                <Link
                                    to="/leads"
                                    className="logo logo-dark"
                                    onClick={handleLogoClick}
                                >

                                    <span className="logo-sm">

                                        <img
                                            src={logoSm}
                                            alt="CRM"
                                            height="30"
                                        />

                                    </span>


                                    <span className="logo-lg">

                                        <img
                                            src={logoDark}
                                            alt="CRM Expert"
                                            height="27"
                                        />

                                    </span>

                                </Link>


                                <Link
                                    to="/leads"
                                    className="logo logo-light"
                                    onClick={handleLogoClick}
                                >

                                    <span className="logo-sm">

                                        <img
                                            src={logoSm}
                                            alt="CRM"
                                            height="30"
                                        />

                                    </span>


                                    <span className="logo-lg">

                                        <img
                                            src={logoLight}
                                            alt="CRM Expert"
                                            height="27"
                                        />

                                    </span>

                                </Link>

                            </div>


                            {/* =================================
                                HAMBURGER
                            ================================= */}
                            <button
                                onClick={toggleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 crm-menu-button"
                                id="topnav-hamburger-icon"
                                aria-label="Toggle menu"
                            >
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>


                            {/* =================================
                                DESKTOP SEARCH
                            ================================= */}

                            <div className="crm-desktop-search">

                                <SearchOption />

                            </div>

                        </div>


                        {/* =================================
                            RIGHT SECTION
                        ================================= */}

                        <div className="d-flex align-items-center crm-header-actions">


                            {/* DESKTOP DARK/LIGHT */}

                            <div className="crm-desktop-only">

                                <LightDark
                                    layoutMode={layoutModeType}
                                    onChangeLayoutMode={
                                        onChangeLayoutMode
                                    }
                                />

                            </div>


                            {/* NOTIFICATIONS */}

                            <NotificationDropdown />


                            {/* PROFILE */}

                            <ProfileDropdown />

                        </div>

                    </div>

                </div>

            </header>


            {/* =========================================
                MOBILE SIDEBAR
            ========================================= */}

            

        </>
    );
};


export default Header;